<template>
  <div>
   
    <div class="service" ref="fuwul">
      <div 
      >
        <div class="servertext">
        
          <p class="integrated animated zoomIn">集成多种服务</p>
        </div>

        <div class="fuwu">
            <div  class='servicintrduce'>
              <router-link to="/cz">
                <div class="item animated zoomIn">
                  <i class="icon iconfont icon-chezhuxinxi"></i>
                </div>
              </router-link>
               <p class="servicename animated zoomIn">车主服务</p>
              <!-- <p>查找附近车位</p>
              <p>车位共享</p>
              <p>车位预约</p>
              <p>停车场状态、价格查询</p> -->
            </div>
            

            <div  class='servicintrduce'>
              <router-link to="/parkservice">
                <div class="item animated zoomIn">
                  <i class="icon iconfont icon-tingchechang"></i>
                </div>
                <p class="servicename animated zoomIn">停车场服务</p>
              </router-link>
              <!-- <p>云接入</p>
              <p>互联网管理</p>
              <p>规范收费规则</p> -->
            </div>

            <div  class='servicintrduce'>
              <router-link to="/shopservice">
                <div class="item animated zoomIn">
                  <i class="icon iconfont icon-shangjia"></i>
                </div>
                <p class="servicename animated zoomIn">商家服务</p>
              </router-link>
              <!-- <p>使用电子支付与停车场结算方便快捷</p>
              <p>app发送停车卷</p> -->
            </div>

            <div  class='servicintrduce'>
              <router-link to="#">
                <div class="item animated zoomIn">
                  <i class="icon iconfont icon-pingtaiyingyong"></i>
                </div>
                <p class="servicename animated zoomIn">开放服务</p>
              </router-link>
             
               
            </div>
           
        </div>
      </div>
    </div>
  </div>
</template>
<script >
export default {
  name: "about",
  data() {
    return {
   
      active: false,
     
      show: false,
      scroll: ""  
    };
  },
  methods: {
  }
};
</script>
<style scoped>
.servicintrduce{
  height: 350px;
  width:100%;
  border:1px solid #FFF;
  background-color: #0665ad;
}
.a {
  height: 400px;
}
.integrated {
  font-size: 30px;
  color: #00b0d3;
}
.servicename {
  color: #fff;
  font-size: 20px;
  margin-top: 80px;
  margin-bottom: 30px;
  font-weight: 500;
}
.servertext {
  margin-bottom: 20px;
}
.servertext p:first-child {
  font-size: 25px;
  color: #8c949a;
}
.service {
  text-align: center;
  padding-top: 80px;
  margin-bottom: 30px;
  min-height: 600px;
  max-width: 100%;
  margin: 0px auto;
}
.item {
  border-radius: 50%;
  border: 1px solid #40bfdb;
  width: 130px;
  margin: 0px auto;
  margin-top: 100px;
  height: 130px;
  background-color: #f5fafb;
}
.item i {
  font-size: 60px !important;
  color: #40bfdb;
  line-height: 130px;
}
.item:hover {
  background-color: #40bfdb;
  /* animation: move 2s linear infinite; */
}
.textdetaile {
  padding-left: 30px;
}
.aboutus {
  font-size: 1.5rem;
  font-weight: 400;
  color: #00b0d3;
 
  text-align: center;
  padding: 20px;
  padding-bottom: 50px;
}
.row-bg {
  margin: 0 auto;
  padding: 30px;
}
.text {
  margin-top: 20px;
  font-size: 1.2rem;
}
.about {
  min-height: 600px;
  background: #f8f8f8;
  width: 100%;
   max-width: 1000px;
   margin:0 auto;
}
p {
  color: #333333;

  line-height: 28px;
}
.item:hover i {
  color: #ffffff;
}
.parking {
  min-height: 500px;
}
.fuwu {
  display: flex;
  justify-content:space-around;
  max-width:1200px;
  text-align: center;
  padding-left: 7.5%;
  padding-right: 7.5%;
  margin: 0 auto;
}

</style>



// WEBPACK FOOTER //
// src/components/about.vue